import { Link } from "react-router-dom";

export const Eyebrow = ({ children, dark = false, className = "", ...rest }) => (
  <p
    className={`text-xs font-semibold tracking-[0.28em] uppercase ${dark ? "text-goldlight" : "text-gold"} ${className}`}
    {...rest}
  >
    {children}
  </p>
);

export const Hairline = ({ dark = false, className = "" }) => (
  <div className={`h-px w-full ${dark ? "bg-white/15" : "bg-charcoal/15"} ${className}`} />
);

const baseBtn =
  "inline-flex items-center justify-center gap-3 px-8 py-4 text-xs font-semibold tracking-[0.2em] uppercase transition-[background-color,color,border-color] duration-300";

export const BtnGold = ({ children, className = "", ...props }) => (
  <button
    className={`${baseBtn} bg-gold text-ink hover:bg-ivory ${className}`}
    {...props}
  >
    {children}
  </button>
);

export const BtnOutlineDark = ({ children, className = "", ...props }) => (
  <button
    className={`${baseBtn} border border-white/35 text-ivory hover:border-gold hover:text-goldlight ${className}`}
    {...props}
  >
    {children}
  </button>
);

export const BtnCharcoal = ({ children, className = "", ...props }) => (
  <button
    className={`${baseBtn} bg-charcoal text-ivory hover:bg-gold hover:text-ink ${className}`}
    {...props}
  >
    {children}
  </button>
);

export const LinkBtnGold = ({ to, children, className = "", ...props }) => (
  <Link to={to} className={`${baseBtn} bg-gold text-ink hover:bg-ivory ${className}`} {...props}>
    {children}
  </Link>
);

export const LinkBtnOutlineDark = ({ to, children, className = "", ...props }) => (
  <Link
    to={to}
    className={`${baseBtn} border border-white/35 text-ivory hover:border-gold hover:text-goldlight ${className}`}
    {...props}
  >
    {children}
  </Link>
);

export const LinkBtnCharcoal = ({ to, children, className = "", ...props }) => (
  <Link to={to} className={`${baseBtn} bg-charcoal text-ivory hover:bg-gold hover:text-ink ${className}`} {...props}>
    {children}
  </Link>
);

export const ArrowLink = ({ to, children, dark = false, className = "", ...props }) => (
  <Link
    to={to}
    className={`group inline-flex items-center gap-2 text-xs font-semibold tracking-[0.2em] uppercase transition-colors duration-300 ${
      dark ? "text-ivory hover:text-goldlight" : "text-charcoal hover:text-golddark"
    } ${className}`}
    {...props}
  >
    <span>{children}</span>
    <span className="inline-block transition-transform duration-300 group-hover:translate-x-1.5">→</span>
  </Link>
);
